import { createStore } from 'satcheljs';
export default createStore('calendarConfiguration', {
    calendarConfiguration: null,
})();
//# sourceMappingURL=store.js.map